import { render, staticRenderFns } from "./DictText.vue?vue&type=template&id=0c7f390c&scoped=true&"
import script from "./DictText.vue?vue&type=script&lang=js&"
export * from "./DictText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../salespro-dev/salespro-dev/sources/client/salespro-dev-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7f390c",
  null
  
)

export default component.exports